import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('ProductGroupFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getProductGroupList: function () {
            return $http.get(settings.ApiURL + settings.ProductGroupURL);
        },
        getProductGroupByID: function (id) {
            return $http.get(settings.ApiURL + settings.ProductGroupURL + "/" + id);
        },
        saveProductGroup: function (productGroup) {
            return $http.put(settings.ApiURL + settings.ProductGroupURL, productGroup);
        },
        deleteProductGroup: function (id) {
            return $http.delete(settings.ApiURL + settings.ProductGroupURL + "/" + id);
        }
    };
}]);

app.controller('ProductGroupController',  ['$q', '$scope', 'ProductGroupFactory', '$rootScope', 'settings', 'masterFactory','$uibModal',
    function ($q, $scope, ProductGroupFactory, $rootScope, settings, masterFactory, $uibModal) {
    $rootScope.pageTitle = "Product Group";    
    $scope.productGroupList = [];
    $scope.productGroup = {};
    $scope.newproductGroup = {};    
    $scope.error = "";
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.isNewProductGroup = false;
    $scope.isAssignedProductSelected = false;
    $scope.isUnassignedProductSelected = false;
    $scope.isAssignedDataAreaSelected = false;
    $scope.isUnassignedDataAreaSelected = false;
    $scope.isProductsGridCollapsed = false;
    $scope.isDataAreasGridCollapsed = false;
    $scope.pageSize = 20;

    // Initialization - this runs on load
    var init = function (pageIndex) {
        masterFactory.verifyAuthentication();

        $('#loadingModal').modal({ backdrop: 'static' });
        $q.all([
            ProductGroupFactory.getProductGroupList().success(function (data) {
                $scope.productGroupList = data;
                $scope.refreshGrid(pageIndex, null);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            })
        ]).then(function () {
            
        });
    };   

    init(0);

    // Grid renderers
    $scope.refreshGrid = function (PageIndex, Key) {        
        $('#gridProductGroup').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.productGroupList,
                    type: 'array',
                    key: 'Id'
                }
            },
            columns: [
               { caption: 'Product Group No', dataField: 'Number', cssClass: 'Number', dataType: 'string', alignment: 'center', width: 150 },
               {
                   caption: 'Product Group Name', dataField: 'Name', cssClass: 'Name', dataType: 'string', alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Name)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            contentReadyAction: grdReadyAction,
            filterRow: { visible: true },
            groupPanel: { visible: false, },
            noDataText: "No Product Group Found",
            pager: { showPageSizeSelector: true, allowedPageSizes: [10, 20, 30] },
            paging: { pageSize: $scope.pageSize, pageIndex: PageIndex },
            rowAlternationEnabled: false,
            selection: { mode: 'single' },
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $('#loadingModal').modal({ backdrop: 'static' });
                    ProductGroupFactory.getProductGroupByID(selectedRowsInfo.selectedRowsData[0].Id).success(function (data) {
                        $scope.productGroup = data;
                        $scope.refreshAssignedProductsGrid();
                        $scope.refreshUnAssignedProductsGrid();
                        $scope.refreshAssignedDataAreasGrid();
                        $scope.refreshUnAssignedDataAreasGrid();
                        $scope.isFormVisible = true;
                        $scope.isDeleteVisible = true;
                        $scope.isNewProductGroup = false;
                        ToggleYellowToGreen();
                        $rootScope.pageTitle = "Product Groups";
                        // code to display dialog saying related products are being added to the existing products
                        if ($scope.productGroup.RelatedProducts != null && $scope.productGroup.RelatedProducts.length > 0) {
                            $scope.viewRelatedProductModal();
                        }
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    });
                }
            }
        });

        if (Key != null && Key > 0) {
            var dataGrid = $('#gridProductGroup').dxDataGrid('instance');
            (dataGrid as unknown as FacnmDx).selectRows([Key]);
        }
    };

    $scope.refreshAssignedProductsGrid = function () {
        $scope.isAssignedProductSelected = false;

        $('#gridAssignedProducts').dxDataGrid({
            dataSource: $scope.productGroup.AssignedProducts,
            columns: [
               {    caption: 'Product Number', dataField: 'ProductNumber', cssClass: 'ProductNumber', dataType: 'string', alignment: 'center' },
               {    caption: 'Product Name', dataField: 'ShortProductName', cssClass: 'ShortProductName', dataType: 'string', alignment: 'center',
                    cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.ShortProductName)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            contentReadyAction: resetSelectionColumn,
            filterRow: { visible: true },
            groupPanel: { visible: false, },
            height: 470,
            paging: { pageSize: 10 },
            pager: { showPageSizeSelector: false },
            rowAlternationEnabled: false,
            selection: { mode: 'multiple' },
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData.length > 0) {
                    $scope.isAssignedProductSelected = true;
                }
                else {
                    $scope.isAssignedProductSelected = false;
                }
            }
        });
    };

    $scope.refreshUnAssignedProductsGrid = function () {
        $scope.isUnassignedProductSelected = false;       

        $('#gridUnAssignedProducts').dxDataGrid({
            dataSource: $scope.productGroup.UnassignedProducts,
            columns: [
               { caption: 'Product Number', dataField: 'ProductNumber', cssClass: 'ProductNumber', dataType: 'string', alignment: 'center' },
               {
                   caption: 'Product Name', dataField: 'ShortProductName', cssClass: 'ShortProductName', dataType: 'string', alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.ShortProductName)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            contentReadyAction: resetSelectionColumn,
            filterRow: { visible: true },
            groupPanel: { visible: false },
            height: 470,
            paging: { pageSize: 10 },
            pager: { showPageSizeSelector: false },
            rowAlternationEnabled: false,
            selection: { mode: 'multiple' },
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData.length > 0) {
                    $scope.isUnassignedProductSelected = true;
                }
                else {
                    $scope.isUnassignedProductSelected = false;
                }                
            }
        });
    };

    $scope.refreshAssignedDataAreasGrid = function () {
        $scope.isAssignedDataAreaSelected = false;

        $('#gridAssignedDataAreas').dxDataGrid({
            dataSource: $scope.productGroup.AssignedDataAreas,
            columns: [
               { caption: 'Data Area No', dataField: 'Number', cssClass: 'Number', dataType: 'string', alignment: 'center' },
               {
                   caption: 'Data Area Name', dataField: 'Name', cssClass: 'Name', dataType: 'string', alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Name)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            contentReadyAction: resetSelectionColumn,
            filterRow: { visible: true },
            groupPanel: { visible: false },
            height: 470,
            paging: { pageSize: 10 },
            pager: { showPageSizeSelector: false },
            rowAlternationEnabled: false,
            selection: { mode: 'multiple' },
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData.length > 0) {
                    $scope.isAssignedDataAreaSelected = true;
                }
                else {
                    $scope.isAssignedDataAreaSelected = false;
                }
            }
        });
    };

    $scope.refreshUnAssignedDataAreasGrid = function () {
        $scope.isUnassignedDataAreaSelected = false;        

        $('#gridUnAssignedDataAreas').dxDataGrid({
            dataSource: $scope.productGroup.UnassignedDataAreas,
            columns: [
               { caption: 'Data Area No', dataField: 'Number', cssClass: 'Number', dataType: 'string', alignment: 'center' },
               {
                   caption: 'Data Area Name', dataField: 'Name', cssClass: 'Name', dataType: 'string', alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Name)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            contentReadyAction: resetSelectionColumn,
            filterRow: { visible: true },
            groupPanel: { visible: false },
            height: 470,
            paging: { pageSize: 10 },
            pager: { showPageSizeSelector: false },
            rowAlternationEnabled: false,
            selection: { mode: 'multiple' },
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData.length > 0) {
                    $scope.isUnassignedDataAreaSelected = true;
                }
                else {
                    $scope.isUnassignedDataAreaSelected = false;
                }
            }
        });
    };

    //Button click functions
    $scope.addNewProductGroup = function () {
        $rootScope.pageTitle = "New Product Group";
        ProductGroupFactory.getProductGroupByID(0).success(function (data) {
            $scope.productGroup = data;
            $scope.refreshAssignedProductsGrid();
            $scope.refreshUnAssignedProductsGrid();
            $scope.refreshAssignedDataAreasGrid();
            $scope.refreshUnAssignedDataAreasGrid();
            $scope.isFormVisible = true;
            $scope.isDeleteVisible = false;
            $scope.isNewProductGroup = true;
            ToggleGreenToYellow();
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        });
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            ProductGroupFactory.deleteProductGroup($scope.productGroup.Id).success(function (data) {
                ProductGroupFactory.getProductGroupList().success(function (data) {
                    var dataGrid = $('#gridProductGroup').dxDataGrid('instance');
                    var pageIndex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    $scope.productGroupList = data;
                    $scope.cancelForm();
                    $scope.refreshGrid(pageIndex, null);
                }).error(function () {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Product Group successfully' });
                });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }
    };

    $scope.cancelForm = function () {
        var dataGrid = $('#gridProductGroup').dxDataGrid('instance');
        dataGrid.clearSelection();
        $scope.isFormVisible = false;
        $scope.productGroupForm.$submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    };

    $scope.reset = function (type) {        
            if (type == 'update') { // get db bankaccount and set to scope.bankaccount.
                $('#loadingModal').modal({ backdrop: 'static' });
                ProductGroupFactory.getProductGroupByID($scope.productGroup.Id).success(function (data) {
                    $scope.productGroup = data;
                    $scope.refreshAssignedProductsGrid();
                    $scope.refreshUnAssignedProductsGrid();
                    $scope.refreshAssignedDataAreasGrid();
                    $scope.refreshUnAssignedDataAreasGrid();
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
            else {
                angular.copy($scope.newproductGroup, $scope.productGroup);
                $scope.refreshAssignedProductsGrid();
                $scope.refreshUnAssignedProductsGrid();
                $scope.refreshAssignedDataAreasGrid();
                $scope.refreshUnAssignedDataAreasGrid();
            }
            
            $scope.productGroupForm.$setPristine();
            $scope.productGroupForm.$submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Product Group details were reset' });
    };

    $scope.submitForm = function () {
        if ($scope.productGroupForm.$valid) {
            $scope.saveProductGroup();
        } 
    };

    $scope.saveProductGroup = function () {
        var pageindex, id;
        $scope.closeModelStateErrors();
        //$('#loadingModal').modal({ backdrop: 'static' });
        ProductGroupFactory.saveProductGroup($scope.productGroup).success(function (productGroupId) {
            ProductGroupFactory.getProductGroupList().success(function (data) {
                var dataGrid = $('#gridProductGroup').dxDataGrid('instance');
                $scope.pageSize = dataGrid.pageSize();
                pageindex = dataGrid.pageIndex();
                $scope.productGroupList = data;
                if ($scope.productGroup.Id > 0) {
                    $scope.refreshGrid(pageindex, $scope.productGroup.Id);
                    $scope.refreshAssignedProductsGrid();
                    $scope.refreshUnAssignedProductsGrid();
                    $scope.refreshAssignedDataAreasGrid();
                    $scope.refreshUnAssignedDataAreasGrid();
                }
                else {
                    $scope.cancelForm();
                    $scope.refreshGrid(pageindex, null);
                }
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function (data) {
                if ($scope.productGroup.Id > 0) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Product Group successfully' });
                }
                else {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Product Group successfully' });
                }
            });
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        }).finally(function () {
            //$('#loadingModal').modal('hide');
        });
    };

    // Selecting and Unselecting grid items on details panel
    $scope.assignProducts = function () {
        var dataGrid = $('#gridUnAssignedProducts').dxDataGrid('instance');
        var selectedRows = dataGrid.getSelectedRowsData();
        var i = 0; var len = selectedRows.length;
        for (; i < len; i++) {
            var prd = $scope.filter($scope.productGroup.AssignedProducts, selectedRows[i].Id);
            $scope.productGroup.UnassignedProducts.splice($scope.productGroup.UnassignedProducts.indexOf(selectedRows[i]), 1);
            if (prd == null) {
                $scope.productGroup.AssignedProducts.push(selectedRows[i]);
            }
        }
        $scope.refreshAssignedProductsGrid();
        $scope.refreshUnAssignedProductsGrid();
        dataGrid.clearSelection();
    };

    $scope.unassignProducts = function () {
        var dataGrid = $('#gridAssignedProducts').dxDataGrid('instance');
        var selectedRows = dataGrid.getSelectedRowsData();
        var i = 0; var len = selectedRows.length;
        for (; i < len; i++) {
            $scope.productGroup.AssignedProducts.splice($scope.productGroup.AssignedProducts.indexOf(selectedRows[i]), 1);
            $scope.productGroup.UnassignedProducts.push(selectedRows[i]);
        }
        $scope.refreshAssignedProductsGrid();
        $scope.refreshUnAssignedProductsGrid();
        dataGrid.clearSelection();
    };

    $scope.assignDataAreas = function () {
        var dataGrid = $('#gridUnAssignedDataAreas').dxDataGrid('instance');
        var selectedRows = dataGrid.getSelectedRowsData();
        var i = 0; var len1 = selectedRows.length;
        for (; i < len1; i++) {
            var da = $scope.filter($scope.productGroup.AssignedDataAreas, selectedRows[i].Id);
            $scope.productGroup.UnassignedDataAreas.splice($scope.productGroup.UnassignedDataAreas.indexOf(selectedRows[i]), 1);
            if (da == null) {
                $scope.productGroup.AssignedDataAreas.push(selectedRows[i]);
            }
        }
        $scope.refreshAssignedDataAreasGrid();
        $scope.refreshUnAssignedDataAreasGrid();
        dataGrid.clearSelection();
    };

    $scope.unassignDataAreas = function () {
        var dataGrid = $('#gridAssignedDataAreas').dxDataGrid('instance');
        var selectedRows = dataGrid.getSelectedRowsData();
        var i = 0; var len = selectedRows.length;
        for (; i < len; i++) {
            $scope.productGroup.AssignedDataAreas.splice($scope.productGroup.AssignedDataAreas.indexOf(selectedRows[i]), 1);
            $scope.productGroup.UnassignedDataAreas.push(selectedRows[i]);
        }
        $scope.refreshAssignedDataAreasGrid();
        $scope.refreshUnAssignedDataAreasGrid();
        dataGrid.clearSelection();
    };

    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridProductGroup', settings.GridMarginHeight);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridProductGroup', settings.GridMarginHeight);
    };

    collapsibleHeaderClickEvent($scope);    

    $scope.productsGridExpanded = function () {
        var dataGrid1 = $('#gridUnAssignedProducts').dxDataGrid('instance');
        dataGrid1.repaint();
        var dataGrid2 = $('#gridAssignedProducts').dxDataGrid('instance');
        dataGrid2.repaint();
    };

    $scope.dataAreaGridExpanded = function () {
        var dataGrid1 = $('#gridUnAssignedDataAreas').dxDataGrid('instance');
        dataGrid1.repaint();
        var dataGrid2 = $('#gridAssignedDataAreas').dxDataGrid('instance');
        dataGrid2.repaint();
    };

    $scope.filter = function (input, id) {
        var i = 0, len = input.length;
        for (; i < len; i++) {
            if (+input[i].Id == +id) {
                return input[i];
            }
        }
        return null;
    };

    $scope.closeAlert = function () {
        $scope.error = null;
    };

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

    $scope.viewRelatedProductModal = function () {
        var modalInstance = $uibModal.open({
            templateUrl: 'app-legacy/Entities/templates/RelatedProductModal.html',
            controller: 'RelatedProductModalController',
            controllerAs: 'modalVm',
            size: 'md',
            scope: $scope,
            resolve: {
                RelatedProducts: function() {
                    return $scope.productGroup.RelatedProducts;
                }
            }
        });

        modalInstance.result.then(function (RelatedProducts) {
            if ($scope.productGroup.RelatedProducts != null && $scope.productGroup.RelatedProducts.length > 0) {
                $scope.saveProductGroup();
            }            
        }, function () {
            if ($scope.productGroup.RelatedProducts != null && $scope.productGroup.RelatedProducts.length > 0) {
                $scope.saveProductGroup();
            }
        });
    };

}]);

app.controller('RelatedProductModalController', ['$scope', 'ProductGroupFactory', '$uibModalInstance', '$uibModal', 'RelatedProducts',
    function ($scope, ProductGroupFactory, $uibModalInstance, $uibModal, RelatedProducts) {
        var modalVm = this;

        init();

        modalVm.Ok = function () {
            $uibModalInstance.close(modalVm.RelatedProducts);
        };
        
        function init() {
            modalVm.RelatedProducts = RelatedProducts;            
        };
    }]);
